<template>
	<div class="subtitle"><slot></slot></div>
</template>

<script setup></script>

<style scoped lang="scss">
.subtitle {
	font-size: 1.2rem;
	font-weight: 300;
	line-height: 1.2;

	&.centered {
		text-align: center;
	}
}
</style>
